import { useQuery } from "@tanstack/react-query";

import useApiHelper from "../../hooks/useApiHelper";
import useQSBuilder from "../../hooks/useQSBuilder";
import { IDefaultPaginatedResponse } from "../../models/DefaultResponse";
import { ITicket } from "../../models/Tickets/Ticket";
import { TicketQueryKeys } from "./keys";

export interface IUseTicketsProps {
  searchTerm?: string;
  customerId?: string;
  status?: number;
  priority?: number;
  type?: number;
  /** Staff-only triage decision - only narrows feature requests. */
  featureDecision?: number;
  assignedToUserId?: string;
  quickFilter?: string;
  includeResolved?: boolean;
  sortBy?: string;
  sortDescending?: boolean;
  pageNumber?: number;
  itemsPerPage?: number;
  includeNotes?: boolean;
  enabled?: boolean;
}

/**
 * Paginated, filtered and sorted server-side. The list page drives the shared
 * Table component instead of this hook; this is for anything needing tickets
 * outside that table.
 */
export default function useTickets({
  enabled = true,
  ...options
}: IUseTicketsProps = {}) {
  const { get } = useApiHelper();
  const buildQS = useQSBuilder();

  const definedOptions = Object.fromEntries(
    Object.entries(options).filter(([, value]) => value !== undefined && value !== ""),
  );
  const queryString = buildQS(definedOptions);

  const tickets = useQuery({
    queryKey: [...TicketQueryKeys.all(), queryString],
    queryFn: () =>
      get<IDefaultPaginatedResponse<ITicket[]>>(`/ticket${queryString}`),
    enabled,
  });

  return {
    tickets,
  };
}
